export default __webpack_public_path__ + "static/media/addOnBenefitshelpMobileHighlight@2x.119fa2ec.png";